import { v4 } from 'uuid';
import { NetworkEntryCreator } from './networkTraffic';
import { SESSION_STORAGE } from './constants/sessionStorage';

const APIRoot = process.env.REACT_APP_API_URL;

export const params = (method, body, acceptHeader) => {
  const params2 = paramsBase(method, body, acceptHeader);

  params2.headers['Authorization'] =
    'Bearer ' + sessionStorage.getItem(SESSION_STORAGE.KEYCLOAK_TOKEN);
  return params2;
};

export const paramsBase = (method, body, acceptHeader) => {
  const parameters = {
    method,
    body:
      method === 'GET' || method === 'DELETE'
        ? undefined
        : JSON.stringify(body),
    headers: {
      'X-Correlation-ID': v4(),
      'Content-Type': acceptHeader,
      Accept: acceptHeader
    }
  };

  return parameters;
};

const error = (path, method, body) => ({
  path: path.split('/')[0],
  method,
  body,
  type: 'ApiError'
});

export const APIfetch = async (
  path,
  search = '',
  method = 'GET',
  body = null,
  acceptHeader = 'application/json'
) => {
  const fullPath = APIRoot + path + search;

  let options,
    response = null;
  try {
    options = params(method, body, acceptHeader);
    response = await fetch(fullPath, options);
  } catch (e) {
    throw error('Network error', method, body ? body : {});
  }

  const networkEntryCreator = new NetworkEntryCreator(
    fullPath,
    options,
    response
  );

  if (!response) {
    throw error(path, method, body);
  }

  if (response.status === 204) {
    networkEntryCreator.addResponseBody(response.body).create();
    return response;
  }

  if (response.status === 401) {
    window.location = '/hospiadmission';
    return response;
  }

  if (response.status === 406) {
    document.cookie =
      'HospitalID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.dkv-mc.be; Secure; HttpOnly; SameSite=Strict';
    window.location = response.url + '&error=SESSION_CLOSED';
    return response;
  }

  if (response.ok) {
    const body2 = await response.json();
    networkEntryCreator.addResponseBody(body2).create();
    return body2;
  }

  if (response.body) {
    let body3 = {};
    try {
      body3 = await response.json();
    } catch (e) {}
    networkEntryCreator.addResponseBody(body3).create();
    throw error(path, method, body3);
  } else {
    const body4 = JSON.parse(await response.text());
    networkEntryCreator.addResponseBody(body4).create();
    throw error(path, method, body4);
  }
};
